// File: src/components/ScrollProgressIndicator.js

import React from 'react';
import { motion, useScroll } from 'framer-motion';

const ScrollProgressIndicator = ({ type = 'line' }) => {
  const { scrollYProgress } = useScroll();

  if (type === 'circle') {
    return (
      <svg className="scroll-progress-circle" width="50" height="50" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="30" pathLength="1" className="bg" />
        <motion.circle
          cx="50"
          cy="50"
          r="30"
          pathLength="1"
          className="indicator"
          style={{ pathLength: scrollYProgress }}
        />
      </svg>
    );
  }

  return (
    <motion.div
      className="scroll-progress-line"
      style={{ scaleX: scrollYProgress }}
    />
  );
};

export default ScrollProgressIndicator;